<template>

    <div class="snap-card">
        <div class="pic cvr" :style="{ backgroundImage : 'url('+ posterSrc +')' }"></div>
        <span class="cap-title ft-xbld">{{ title }}</span>
        <div class="hvr">
            <span class="ico">
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM11.5 11.5V6.5H14.5V11.5H19.5V14.5H14.5V19.5H11.5V14.5H6.5V11.5H11.5Z" fill="#FFBB36"/>
                </svg>
            </span>
        </div>
    </div>

</template>

<script>

    export default {

        name: 'SnapCard',

        props: {
            posterSrc: String,
            title: String,
        },

    }
</script>